import { useTheme } from 'styled-components';

import CloseIcon from 'icons/CloseIcon';

/* Styled Components */
import {
  VideoOverlay,
  VideoWrapper,
  VideoContentWrapper,
  WishCloseWrapper,
} from 'styles/common/VideoModal';

type PropsType = {
  url: string;
  onClose: () => void;
};

const VideoModal = ({ url, onClose }: PropsType) => {
  const theme = useTheme();
  return (
    <VideoOverlay onClick={onClose}>
      <WishCloseWrapper>
        <CloseIcon
          overrideStyle={{ color: theme.white, width: 32, height: 32 }}
        />
      </WishCloseWrapper>
      <VideoWrapper>
        <VideoContentWrapper>
          <iframe
            src={url}
            frameBorder="0"
            allow="encrypted-media; picture-in-picture; autoplay;"
            allowFullScreen
            title="video"
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          />
        </VideoContentWrapper>
      </VideoWrapper>
    </VideoOverlay>
  );
};

export default VideoModal;
